import { TriangleAlertIcon } from '@air/design-icons';

import { type WorkspaceAgentPreviewCardFrameProps } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/cards/WorkspaceAgentPreviewCardFrame';

export type WorkspaceAgentPreviewCardPlaceholderInput = {
  /** Settled and missing, not still resolving. */
  isUnavailable?: boolean;
  label: string;
  referenceId?: string;
};

/** Frame props, not a card: the host renders one frame for every state, so the close button Radix autofocused survives the swap. */
export const toWorkspaceAgentPreviewCardPlaceholderProps = ({
  isUnavailable = false,
  label,
  referenceId,
}: WorkspaceAgentPreviewCardPlaceholderInput): WorkspaceAgentPreviewCardFrameProps => ({
  locationLabel: null,
  locationTitle: null,
  mediaFallback: isUnavailable ? (
    <TriangleAlertIcon aria-hidden className="ads:text-icon-error text-red-11" size={32} />
  ) : (
    <span
      aria-hidden
      className="size-8 animate-pulse rounded-4 ads:bg-ads-gray-4 bg-gray-4 motion-reduce:animate-none"
    />
  ),
  mediaImageUrl: null,
  referenceId,
  testId: 'WORKSPACE_AGENT_PREVIEW_CARD_PLACEHOLDER',
  title: label,
  titleTone: isUnavailable ? 'unavailable' : 'pending',
});
